import { ResultOf } from "@graphql-typed-document-node/core";
import { useMemo } from "react";
import { CombinedError, useQuery } from "urql";

import { getFragmentData, graphql } from "@/gen";

const useTournament_Tournament = graphql(`
    fragment useTournament_Tournament on Tournament {
        id
        title
        shortTitle
        location
        description
        startAt
        endAt
        heroImageId
        thumbnailImageId
        badgeImageId
        format
        evaluationSurgeProtection
        players {
            id
            name
            fideId
            nickname
            imageId
        }
        previousWinnerPlayerId
        previousWinner {
            id
            nickname
            name
            fideId
            imageId
        }
        isInternalOnly
        isHidden
        manualStandings
        manualStandingsList {
            player {
                id
                name
            }
            points
            createdAt
        }
        countryStandingsEnabled
        countryStandingsTopPlayers
        stages {
            id
            ...TournamentStageTable_TournamentStage
        }
        tournamentSeriesId
        standingsCalculation
        chesscomInternalSlug
    }
`);

export type TournamentT = ResultOf<typeof useTournament_Tournament>;

export const TournamentStageTable_TournamentStage = graphql(`
    fragment TournamentStageTable_TournamentStage on TournamentStage {
        id
        title
        description
        kind
        order
        createdAt
    }
`);

export type TournamentStageT = ResultOf<typeof TournamentStageTable_TournamentStage>;

export const useTournament: (tournamentId?: string) => {
    tournament: TournamentT | null | undefined;
    loading: boolean;
    error: CombinedError | undefined;
    refetch: () => void;
} = (tournamentId?: string) => {
    const [result, refetch] = useQuery({
        query: graphql(`
            query tournamentQuery($id: UUID!) {
                tournament(id: $id) {
                    id
                    title
                    stages {
                        id
                        ...TournamentStageTable_TournamentStage
                    }
                    ...useTournament_Tournament
                }
            }
        `),
        variables: {
            id: tournamentId!,
        },
        pause: !tournamentId,
    });

    const tournament = useMemo(
        () => getFragmentData(useTournament_Tournament, result.data?.tournament),
        [result.data]
    );

    return {
        tournament,
        loading: result.fetching,
        error: result.error,
        refetch,
    };
};
